var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Checkbox, Select } from 'antd';
import { isEmpty } from 'ramda';
import React, { useEffect, useRef, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { GET_NATIONALITIES } from '../../redux/actions/accountActions';
import { getNationalities } from '../../redux/selectors';
import './Select.scss';
var LIST_HEIGHT = 200;
var MAX_COUNT = 5;
function optionsFetcher(dispatch) {
    return function (_a) {
        var searchName = _a.searchName, _b = _a.limit, limit = _b === void 0 ? 50 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, excludeIds = _a.excludeIds;
        dispatch({
            type: GET_NATIONALITIES,
            payload: {
                searchName: searchName,
                limit: limit,
                offset: offset,
                excludeIds: excludeIds,
            },
        });
    };
}
var defaultOptionMapper = function (_a) {
    var name = _a.name, id = _a.id;
    return {
        label: name,
        value: id,
    };
};
export var TagSelect = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? 'Subject(s) of interest' : _b, _c = _a.optionMapper, optionMapper = _c === void 0 ? defaultOptionMapper : _c, _d = _a.listHeight, listHeight = _d === void 0 ? LIST_HEIGHT : _d, _e = _a.maxCount, maxCount = _e === void 0 ? MAX_COUNT : _e, props = __rest(_a, ["value", "onChange", "placeholder", "optionMapper", "listHeight", "maxCount"]);
    var dispatch = useAppDispatch();
    var nationality = useAppSelector(getNationalities);
    var fetchOptions = useRef(optionsFetcher(dispatch));
    var search = useRef('');
    var _f = useState(), options = _f[0], setOptions = _f[1];
    var _g = useState(value || []), localValue = _g[0], setLocalValue = _g[1];
    useEffect(function () {
        if (nationality.length > 0) {
            var parsedItems = nationality.map(function (item) { return optionMapper(item); });
            setOptions(parsedItems);
        }
    }, [nationality, optionMapper]);
    useEffect(function () {
        if (value) {
            setLocalValue(value);
        }
    }, [value]);
    var debounced = useDebouncedCallback(function (inputValue) {
        var searchName = inputValue.trim();
        if (isEmpty(searchName))
            return;
        fetchOptions.current({
            searchName: searchName,
        });
    }, 300);
    var handleSearch = function (inputValue) {
        search.current = inputValue.trim();
        debounced(inputValue);
    };
    var onDropdownVisibleChange = function (open) {
        if (open && !options) {
            fetchOptions.current({
                searchName: search.current,
            });
        }
    };
    // const handlePopupScroll = useCallback(
    //     (event) => {
    //         const target = event.target
    //         if (target.scrollTop + listHeight === target.scrollHeight) {
    //             console.log('load more')
    //             if (total > offset + limit) {
    //                 fetchOptions.current({
    //                     searchName: '',
    //                     limit: limit,
    //                     offset: offset + limit,
    //                 })
    //                 dispatch({
    //                     type: GET_NATIONALITIES,
    //                     payload: {
    //                         limit: limit,
    //                         offset: offset + limit,
    //                         searchName: search.current,
    //                     },
    //                 })
    //             }
    //         }
    //     },
    //     [dispatch, limit, offset, total, listHeight]
    // )
    var handleBlur = function () {
        search.current = '';
    };
    var handleChange = function (value) {
        setLocalValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    var optionRender = function (option) {
        return (React.createElement("div", { className: "flex flex-row" },
            React.createElement(Checkbox, { checked: localValue.includes(option.value) }),
            React.createElement("p", { className: "ml-1" }, option.label)));
    };
    return (React.createElement(Select, __assign({ mode: "multiple", placeholder: placeholder, popupClassName: "tap-tag-select", 
        // filterOption={false}
        maxCount: maxCount, 
        // notFoundContent={
        //     isLoading ? (
        //         <div className="p-6 text-center">
        //             <Spin size="small" />
        //         </div>
        //     ) : null
        // }
        onChange: handleChange, value: localValue, listHeight: listHeight, 
        // onPopupScroll={handlePopupScroll}
        // onSearch={handleSearch}
        onBlur: handleBlur, onDropdownVisibleChange: onDropdownVisibleChange }, props, { options: options, optionRender: optionRender })));
};
